module.exports = __webpack_public_path__ + "img/wifi2.e4f316e1.gif";